// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-width: 0;
}

/* The field: same height and border as the other inputs */
.select-field {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  height: 48px;
  padding: 0 12px 0 14px;
  border-radius: 10px;
  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.35);
  background: var(--ion-background-color, #fff);
  color: var(--ion-text-color, #000);
  font: inherit;
  font-size: 15px;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.select-field:hover:not(:disabled) {
  border-color: var(--ion-color-primary);
}
.select-field:focus-visible {
  outline: none;
  border-color: var(--ion-color-primary);
  box-shadow: 0 0 0 3px rgba(var(--ion-color-primary-rgb), 0.18);
}
.select-field:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.select-field__icon {
  flex-shrink: 0;
  font-size: 18px;
  color: var(--ion-color-primary);
}
.select-field__value {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.select-field--empty .select-field__value {
  color: var(--ion-color-medium-shade);
}
.select-field__chevron {
  flex-shrink: 0;
  font-size: 16px;
  color: var(--ion-color-medium);
}

/* Choices popover */
ion-popover.select-field-popover {
  --offset-y: 6px;
  --border-radius: 12px;
  --box-shadow: 0 10px 30px -8px rgba(0, 0, 0, 0.25), 0 2px 6px rgba(0, 0, 0, 0.08);
}
ion-popover.select-field-popover::part(content) {
  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.18);
}

.select-field-options {
  display: flex;
  flex-direction: column;
  max-height: 300px;
  padding: 6px;
  overflow-y: auto;
  background: var(--ion-background-color, #fff);
}

.select-field-option {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 42px;
  padding: 0 12px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: var(--ion-text-color, #000);
  font: inherit;
  font-size: 15px;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.12s ease;
}
.select-field-option:hover, .select-field-option:focus-visible {
  outline: none;
  background: rgba(var(--ion-color-medium-rgb), 0.1);
}
.select-field-option__label {
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
}
.select-field-option ion-icon {
  flex-shrink: 0;
  font-size: 18px;
  color: var(--ion-color-primary);
}
.select-field-option--selected {
  font-weight: 600;
  color: var(--ion-color-primary-shade);
  background: rgba(var(--ion-color-primary-rgb), 0.08);
}`, "",{"version":3,"sources":["webpack://./src/components/general components/select-field/select-field.component.scss","webpack://./src/components/general%20components/select-field/select-field.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;ACCF;;ADEA,0DAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,yDAAA;EACA,6CAAA;EACA,kCAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0DAAA;ACCF;ADCE;EACE,sCAAA;ACCJ;ADEE;EACE,aAAA;EACA,sCAAA;EACA,8DAAA;ACAJ;ADGE;EACE,mBAAA;EACA,YAAA;ACDJ;ADIE;EACE,cAAA;EACA,eAAA;EACA,+BAAA;ACFJ;ADKE;EACE,OAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;ACHJ;ADME;EACE,oCAAA;ACJJ;ADOE;EACE,cAAA;EACA,eAAA;EACA,8BAAA;ACLJ;;ADSA,oBAAA;AACA;EACE,eAAA;EACA,qBAAA;EACA,iFAAA;ACNF;ADQE;EACE,yDAAA;ACNJ;;ADUA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,6CAAA;ACPF;;ADUA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,kCAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;ACPF;ADSE;EAEE,aAAA;EACA,kDAAA;ACRJ;ADWE;EACE,OAAA;EACA,YAAA;EACA,uBAAA;ACTJ;ADYE;EACE,cAAA;EACA,eAAA;EACA,+BAAA;ACVJ;ADaE;EACE,gBAAA;EACA,qCAAA;EACA,oDAAA;ACXJ","sourcesContent":[":host {\n  display: block;\n  min-width: 0;\n}\n\n/* The field: same height and border as the other inputs */\n.select-field {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  height: 48px;\n  padding: 0 12px 0 14px;\n  border-radius: 10px;\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.35);\n  background: var(--ion-background-color, #fff);\n  color: var(--ion-text-color, #000);\n  font: inherit;\n  font-size: 15px;\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n  &:hover:not(:disabled) {\n    border-color: var(--ion-color-primary);\n  }\n\n  &:focus-visible {\n    outline: none;\n    border-color: var(--ion-color-primary);\n    box-shadow: 0 0 0 3px rgba(var(--ion-color-primary-rgb), 0.18);\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n\n  &__icon {\n    flex-shrink: 0;\n    font-size: 18px;\n    color: var(--ion-color-primary);\n  }\n\n  &__value {\n    flex: 1;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &--empty &__value {\n    color: var(--ion-color-medium-shade);\n  }\n\n  &__chevron {\n    flex-shrink: 0;\n    font-size: 16px;\n    color: var(--ion-color-medium);\n  }\n}\n\n/* Choices popover */\nion-popover.select-field-popover {\n  --offset-y: 6px;\n  --border-radius: 12px;\n  --box-shadow: 0 10px 30px -8px rgba(0, 0, 0, 0.25), 0 2px 6px rgba(0, 0, 0, 0.08);\n\n  &::part(content) {\n    border: 1px solid rgba(var(--ion-color-medium-rgb), 0.18);\n  }\n}\n\n.select-field-options {\n  display: flex;\n  flex-direction: column;\n  max-height: 300px;\n  padding: 6px;\n  overflow-y: auto;\n  background: var(--ion-background-color, #fff);\n}\n\n.select-field-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 42px;\n  padding: 0 12px;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--ion-text-color, #000);\n  font: inherit;\n  font-size: 15px;\n  text-align: left;\n  cursor: pointer;\n  transition: background-color 0.12s ease;\n\n  &:hover,\n  &:focus-visible {\n    outline: none;\n    background: rgba(var(--ion-color-medium-rgb), 0.1);\n  }\n\n  &__label {\n    flex: 1;\n    min-width: 0;\n    overflow-wrap: anywhere;\n  }\n\n  ion-icon {\n    flex-shrink: 0;\n    font-size: 18px;\n    color: var(--ion-color-primary);\n  }\n\n  &--selected {\n    font-weight: 600;\n    color: var(--ion-color-primary-shade);\n    background: rgba(var(--ion-color-primary-rgb), 0.08);\n  }\n}\n",":host {\n  display: block;\n  min-width: 0;\n}\n\n/* The field: same height and border as the other inputs */\n.select-field {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  height: 48px;\n  padding: 0 12px 0 14px;\n  border-radius: 10px;\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.35);\n  background: var(--ion-background-color, #fff);\n  color: var(--ion-text-color, #000);\n  font: inherit;\n  font-size: 15px;\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.select-field:hover:not(:disabled) {\n  border-color: var(--ion-color-primary);\n}\n.select-field:focus-visible {\n  outline: none;\n  border-color: var(--ion-color-primary);\n  box-shadow: 0 0 0 3px rgba(var(--ion-color-primary-rgb), 0.18);\n}\n.select-field:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n.select-field__icon {\n  flex-shrink: 0;\n  font-size: 18px;\n  color: var(--ion-color-primary);\n}\n.select-field__value {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.select-field--empty .select-field__value {\n  color: var(--ion-color-medium-shade);\n}\n.select-field__chevron {\n  flex-shrink: 0;\n  font-size: 16px;\n  color: var(--ion-color-medium);\n}\n\n/* Choices popover */\nion-popover.select-field-popover {\n  --offset-y: 6px;\n  --border-radius: 12px;\n  --box-shadow: 0 10px 30px -8px rgba(0, 0, 0, 0.25), 0 2px 6px rgba(0, 0, 0, 0.08);\n}\nion-popover.select-field-popover::part(content) {\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.18);\n}\n\n.select-field-options {\n  display: flex;\n  flex-direction: column;\n  max-height: 300px;\n  padding: 6px;\n  overflow-y: auto;\n  background: var(--ion-background-color, #fff);\n}\n\n.select-field-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 42px;\n  padding: 0 12px;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--ion-text-color, #000);\n  font: inherit;\n  font-size: 15px;\n  text-align: left;\n  cursor: pointer;\n  transition: background-color 0.12s ease;\n}\n.select-field-option:hover, .select-field-option:focus-visible {\n  outline: none;\n  background: rgba(var(--ion-color-medium-rgb), 0.1);\n}\n.select-field-option__label {\n  flex: 1;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n.select-field-option ion-icon {\n  flex-shrink: 0;\n  font-size: 18px;\n  color: var(--ion-color-primary);\n}\n.select-field-option--selected {\n  font-weight: 600;\n  color: var(--ion-color-primary-shade);\n  background: rgba(var(--ion-color-primary-rgb), 0.08);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
